import { render, staticRenderFns } from "./orcamentos.vue?vue&type=template&id=7aff57ed"
import script from "./orcamentos.ts?vue&type=script&lang=js&external"
export * from "./orcamentos.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\TafStore.PharmUP.Client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7aff57ed')) {
      api.createRecord('7aff57ed', component.options)
    } else {
      api.reload('7aff57ed', component.options)
    }
    module.hot.accept("./orcamentos.vue?vue&type=template&id=7aff57ed", function () {
      api.rerender('7aff57ed', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parent/home/fastaction/orcamentos/orcamentos.vue"
export default component.exports